import {XauditModel} from '../xaudit.model';
import {AddressDataModel} from '../person/address-data.model';
import {FeeScheduleDataModel} from '../fee-schedule/fee-schedule-data.model';
import {InsuranceExplosionDataModel} from '../insurance/insurance-explosion-data.model';
import {ContactDataModel} from '../person/contact-data.model';
import {OrganizationContactDataModel} from './organization-contact-data.model';
import {OrganizationAddressDataModel} from './organization-address-data.model';

export class OrganizationDataModel extends XauditModel {
  AddressId: string;
  OrganizationID: string;
  OrganizationName: string;
  TDOIC: number;
  enumOrganizationTypeId: string;
  Description: string;

  // Navigation properties from the backend
  // TODO: dataAddress should not be used anymore.  Use dataOrganizationAddresses
  dataAddress: AddressDataModel;
  ///////////////////////////////////////////////////////////////////////////////
  dataOrganizationContacts: OrganizationContactDataModel[] = [];
  dataOrganizationAddresses: OrganizationAddressDataModel[] = [];

  // Misc
  dataContacts: OrganizationContactDataModel[] = [];
  dataFeeSchedules: FeeScheduleDataModel[];
  dataInsuranceExplosions: InsuranceExplosionDataModel[];
  isSaved: boolean;
  isNew: boolean = false;
  isExpanded: false;
}
